var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import { colorPalette } from '../../colorPalette';
export const Tooltip = (props) => {
    const { children, tooltipVariants = 'standard', slotProps } = props, rest = __rest(props, ["children", "tooltipVariants", "slotProps"]);
    return (React.createElement(MuiTooltip, Object.assign({}, rest, { PopperProps: {
            container: () => {
                const id = 'hypernova-class-wrapper';
                const hpernovaClassWrapper = document.getElementById(id);
                if (hpernovaClassWrapper) {
                    return hpernovaClassWrapper;
                }
                const elemDiv = document.createElement('div');
                elemDiv.classList.add('_hy');
                elemDiv.id = id;
                document.body.appendChild(elemDiv);
                return elemDiv;
            },
        }, slotProps: Object.assign({ tooltip: {
                sx: Object.assign(Object.assign({}, (tooltipVariants === 'outlined' && {
                    color: colorPalette.gray800,
                    backgroundColor: 'white',
                    border: `2px solid ${colorPalette.gray400}`,
                })), { maxWidth: 'none', padding: 0, borderRadius: 0 }),
            }, arrow: {
                sx: tooltipVariants === 'outlined'
                    ? {
                        fontSize: '24px',
                        border: 'none',
                        '&::before': {
                            color: 'green',
                            backgroundColor: 'white',
                            boxShadow: `inset 0 0 0px 1px ${colorPalette.gray400}`,
                            border: `1px solid ${colorPalette.gray400}`,
                        },
                    }
                    : { fontSize: '20px' },
            } }, slotProps) }), children));
};
